// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportPartFormSpellCheck.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * ReportPartFormSpellCheck component
 */
!(function () {
  var React = require('react');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var connect = require('share/enhancers/Izenda.Connect');
  var TinyMCE = require('share/components/controls/TinyMCE/Izenda.TinyMCE');

  var ReportPartFormSpellCheck = React.createClass({
    
    propTypes: {
      content: React.PropTypes.string
    },

    onClosing: function(cb, type) {
      switch (type) {
        case 'accept':
          this.props.onAcceptChange(this.refs.tinyEditor.getContent());
          this.props.onAccept();
          break;
        case 'cancel':
          this.props.onReject();
          break;
      }
    },

    render: function () {
      var localization = this.props.localization;
      var config = {
        browser_spellcheck: true,
        contextmenu: false,
        statusbar: false,
        plugins: []
      };

      return (
        <Popup
          visible
          onClosing={this.onClosing}
          autoClose={false}
          type="none"
        >
          <Popup.Header title={localization.getText("REPORTDESIGNER_LABEL_SPELL_CHECKER")}/>
          <Popup.Body>
            <TinyMCE
              id='izenda-FormSpellCheck'
              ref='tinyEditor'
              config={config}
              content={this.props.content}
            />
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton type='accept'>{localization.getText("COMMON_LABEL_APPLY")}</Popup.ConfirmationButton>
            <Popup.ConfirmationButton type='cancel'>{localization.getText("COMMON_LABEL_CANCEL")}</Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      )
    }
  });

  module.exports = connect()(ReportPartFormSpellCheck);
}());


// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.ReportPartFormSpellCheck.jsx